import React from 'react';
import { kebabCase } from 'lodash/fp';
import type { ActionMenuCustomItemProps } from '@milanote/roma/application';
import { ElementType } from '../../../../common/elements/elementTypes';
import { getElementId, getElementType } from '../../../../common/elements/utils/elementPropertyUtils';
import Icon from '../../../components/icons/Icon';
import type { ElementContextMenuContext } from '../context/elementContextMenuContext';

const DEBUG_ICON_ELEMENT_TYPE_OVERRIDES: Partial<Record<ElementType, ElementType>> = {
    [ElementType.ALIAS_TYPE]: ElementType.BOARD_TYPE,
    [ElementType.ANNOTATION_TYPE]: ElementType.SKETCH_TYPE,
};

/** Resolves debug element types to icon names that exist in the legacy icon registry. */
export const getDebugElementIconName = (elementType: ElementType): string =>
    `element-${kebabCase(DEBUG_ICON_ELEMENT_TYPE_OVERRIDES[elementType] || elementType)}`;

/** Renders one debug row with the selected element's existing type icon and ID. */
export const SelectedElementDetailsMenuItem: React.FC<ActionMenuCustomItemProps<ElementContextMenuContext>> = ({
    context,
    id,
    label,
}) => {
    const element = context.selectedElements.find((selectedElement) => getElementId(selectedElement) === id);
    if (!element) return null;

    return (
        <div className="flex items-center gap-2 font-mono text-xs text-secondary">
            <Icon className="shrink-0 h-5 w-auto shadow-md" name={getDebugElementIconName(getElementType(element))} />
            <span>{label}</span>
        </div>
    );
};
